/**
 * F10.3 observability ingest sink (GH-6519).
 * Registers window.PMA_Observability_send when observability_ingest_url is configured.
 * Privacy: never logs raw payloads to console in production; uses sendBeacon only.
 */
(function () {
  "use strict";

  var QUEUE_KEY = "pma_observability_queue_v1";
  var MAX_QUEUE = 25;

  function getContext() {
    try {
      return typeof window.PMA_Analytics_Context === "object" ? window.PMA_Analytics_Context : {};
    } catch {
      return {};
    }
  }

  function ingestUrl() {
    var ctx = getContext();
    var url = ctx.observability_ingest_url || ctx.observability_endpoint || "";
    return String(url || "").trim();
  }

  function pushQueue(payload) {
    try {
      if (typeof sessionStorage === "undefined") return;
      var raw = sessionStorage.getItem(QUEUE_KEY);
      var queue = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(queue)) queue = [];
      queue.push({ at: new Date().toISOString(), payload: payload });
      while (queue.length > MAX_QUEUE) queue.shift();
      sessionStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
    } catch {}
  }

  function sendToEndpoint(payload) {
    var url = ingestUrl();
    if (!url) return false;
    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: "application/json" });
        return navigator.sendBeacon(url, blob);
      }
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: body,
        keepalive: true,
        credentials: "omit",
      }).catch(function () {});
      return true;
    } catch {
      return false;
    }
  }

  window.PMA_Observability_send = function (payload) {
    if (!payload || typeof payload !== "object") return;
    pushQueue(payload);
    sendToEndpoint(payload);
  };

  document.addEventListener("pma:observability", function (e) {
    if (e && e.detail) window.PMA_Observability_send(e.detail);
  });
})();
